import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const Services = () => {
  const { t, services, lang } = useLang();
  if (!t) return null;
  const s = t.services;

  return (
    <section id="services" className="bg-noir text-creme py-20 md:py-32 relative grain" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <Reveal className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.25em] text-or font-medium">{s.eyebrow}</span>
          <h2 className="fluid-h2 mt-5 text-creme">{s.title}</h2>
          <p className="mt-5 text-creme/55 leading-relaxed">{s.intro}</p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 md:grid-cols-3" data-testid="services-grid">
          {services.map((svc, i) => {
            const item = svc[lang] || svc.fr;
            return (
              <Reveal
                key={svc.id || i}
                delay={i * 70}
                data-testid="service-card"
                className="group rounded-xl border border-creme/10 bg-noir hover:bg-[#211d18] hover:border-or/40 hover:-translate-y-1 transition-[transform,background-color,border-color] duration-300 p-8 min-h-[220px] flex flex-col"
              >
                <div className="flex items-start justify-between">
                  <span className="font-serif text-2xl text-or">{String(i + 1).padStart(2, "0")}</span>
                  <ArrowUpRight size={20} className="text-creme/40 group-hover:text-rouge group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all duration-300" />
                </div>
                <h3 className="mt-6 font-serif text-xl text-creme">{item.title}</h3>
                <p className="mt-3 text-sm text-creme/55 leading-relaxed">{item.desc}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
